module.exports = __webpack_public_path__ + "static/Brochure_EN-4c0554af3718744f223226187ae83c73.pdf";